<template>
  <div class="app-reset-password-confirmation fill-yellow-gradient">
    <div class="composition-wrapper">
      <div class="card card--form">
        <slot name="txtBefore"></slot>
        <ResetPasswordConfirmationPassword
          :success-link="successLink"
          :success-registration-link="successRegistrationLink"
        >
          <template v-for="slot in possibleChildSlotsFor('Password')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ResetPasswordConfirmationPassword>
        <slot name="txtAfter"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import ResetPasswordConfirmationPassword from '@/components/process/generic/ResetPasswordConfirmation/Password.vue'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
import urlParam from '@/mixins/urlParam'

export default {
  name: 'ResetPasswordConfirmationWrapper',
  mixins: [
    transaction('resetPasswordConfirmation'),
    urlParam
  ],
  components: { ResetPasswordConfirmationPassword },
  mounted () {
    let token = this.getURLParam('email_token')
    if (token === '' || token === null) {
      token = this.getURLParam('token')
    }
    this.captureToken(token)
  },
  methods: {
    ...mapMutations('resetPassword', [
      'captureToken'
    ])
  },
  computed: {
    ...mapGetters('resetPassword', [
      'step'
    ])
  },
  props: {
    successLink: {
      type: String,
      default: '#'
    },
    successRegistrationLink: {
      type: String,
      default: '#'
    }
  }
}
</script>
